import { stringify } from 'qs'

import { useCustomSWR } from 'utils/hooks/fetchers'
import RequestCore, { lsGet } from 'utils/request'

export const useVenderSupportItems = (dataSource, swrOptions) => {
  const genUrl = () => {
    try {
      const props = typeof dataSource === 'function' ? dataSource() : dataSource
      if (props === null) {
        return null
      }
      return [
        `/venders/supportServices?${stringify(props)}`,
        RequestCore.getToken(),
      ]
    } catch (err) {
      return null
    }
  }
  return useCustomSWR(genUrl, lsGet, swrOptions)
}
